import { DialogTitle } from '@headlessui/react'
import classNames from 'classnames'
import { X } from 'lucide-react'

import { Button } from '../Button'

const TEXT = {
  close: 'Schließen',
}

export interface DialogTitleWithCloseButtonProps {
  title: string
  className?: string
  onClose: () => void
}

export const DialogTitleWithCloseButton = ({
  title,
  onClose,
  className,
}: DialogTitleWithCloseButtonProps) => (
  <DialogTitle
    className={classNames(
      className,
      'text-color-heading text-h2 flex flex-col-reverse items-start sm:flex-row',
    )}
  >
    <span className={'pb-6'}>{title}</span>
    <Button
      className={'ml-auto text-teal-800'}
      variant={'text'}
      padding={'none'}
      onClick={onClose}
      type='button'
    >
      <span className='sr-only'>{TEXT.close}</span>
      <X
        className='bg-blue h-6 w-6 rounded-lg stroke-3 p-1 text-black hover:text-black'
        aria-hidden
      />
    </Button>
  </DialogTitle>
)
